import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: typeof window !== 'undefined' && localStorage.getItem('deviceType')
    ? localStorage.getItem('deviceType')
    : 'tablet', // Default to tablet on first load
  // Light/dark theme for the native Cara chrome (toolbar, side panel, modals).
  // Does NOT affect the simulated phone or the Pega embed (they own their look).
  theme: typeof window !== 'undefined' && localStorage.getItem('caraTheme')
    ? localStorage.getItem('caraTheme')
    : 'dark',
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    toggleDevice(state) {
      // Only allow toggling between phone and tablet
      const sequence = ['phone', 'tablet'];
      const currentIndex = sequence.indexOf(state.type);
      const nextIndex = (currentIndex + 1) % sequence.length;
      state.type = sequence[nextIndex];
      localStorage.setItem('deviceType', state.type);
    },
    setDevice(state, action) {
      state.type = action.payload;
      localStorage.setItem('deviceType', state.type);
    },
    toggleTheme(state) {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('caraTheme', state.theme);
    },
    setTheme(state, action) {
      state.theme = action.payload === 'light' ? 'light' : 'dark';
      localStorage.setItem('caraTheme', state.theme);
    },
  },
});

export const { toggleDevice, setDevice, toggleTheme, setTheme } = deviceSlice.actions;
export default deviceSlice.reducer;

// No hostServer/applicationAlias localStorage usage found. No changes needed.
